module.exports = __webpack_public_path__ + "static/media/info_icon.beb22a20.svg";